import { render, staticRenderFns } from "./report-vue-container.vue?vue&type=template&id=0b24ca7e&scoped=true"
import script from "./report-vue-container.vue?vue&type=script&lang=ts"
export * from "./report-vue-container.vue?vue&type=script&lang=ts"
import style0 from "./report-vue-container.vue?vue&type=style&index=0&id=0b24ca7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b24ca7e",
  null
  
)

export default component.exports